export default __webpack_public_path__ + "static/media/sonserina.cbfa2493.png";